const Form003SC = {
    stepName: {
        statement: "重要告示",
        applicationForm: "申请表格",
        schoolInformation: "学校资料",
        confirmation: "确认申请",
        choosePlan: "选择甲／乙部",
        partA: "甲部",
        partB: "乙部",
    },
    label: {
        statement: "本人已阅读、明白及同意上述条款及细则。",
        iamSmartCondition: "本人理解此电子表格必须由校监使用「智方便+」签署。",

        choosePlan: {
            formVersion: "请选择合适的申请表版本",
            title1: "本校参加／不参加",
            title2: "「在校免费午膳」计划（「计划」）。",
            planA: "参加",
            planB: "不参加",
            selectionOptions: {
                will: "参加",
                willNot: "不参加",
            },
        },
        partA: {
            errorMsg: {
                maxError: "最大长度为： ",
                error1: "如果选择了其他 ，请详细说明",
                error2: "只允许输入（字母/数字/中文）",
                notTheSame: "（i）和（ii）不能被同时选择",
                errPriceMsg: "适用学生",
                schoolCode: "此项长度必须为{{length}}位",
                titleCorrespondLang: "中英文的称谓须相互对应",
            },
            node: {
                node: "注意",
                note1Normal:
                    "本校会妥善知会家长有关「在校免费午膳」项目，特别是教育局通函第 {{circularNumber}} 号列载为合资格的小学生提供在校免费午膳的参加条款的午膳安排，详情如下 ：",
                node1: "本校会妥善知会家长有关「计划」的详情，并会为合资格的学生提供在校免费午膳。本校的午膳安排详情如下： ",
                node2: "（请在适当的方格内加上√号，并填上所需资料。）",
            },

            title1: "(1) 本校为学生安排在校午膳的方式是：",
            mode: {
                mode1: `(i) 透过现行招标及采购的程序为学生选择午膳供应商。`,
                mode2: "(ii) 由学校聘请员工为学生提供午膳。",
                mode3: "(iii) 其他",
            },
            modePlaceHolder: "请简单说明",
            modeName: "方式",
            // title2: `(2) 2021/22 学年每份学生午膳的定价如下（若为不同组别的学生<span style="text-decoration:underline">分开</span><span style="text-decoration:underline"></span> `,
            firstUnderlineTitle2: "分开",
            beforeFirstUnderlineTitle2:
                "(2) {{schoolYear}} 学年每份学生午膳的定价如下（",
            afterFirstUnderlineTitle2Normal:
                "（例如初小／高小学生），请分别填写；若只有",
            afterFirstUnderlineTitle2:
                "<i>如不同类别的学生（例如初小／高小学生）的午膳价格不同，请分别填写；若只有<u>一个</u>午膳价格，请填写定价 1。</i>",
            secondUnderlineTitle2: "一个",
            afterSecondUnderlineTitle2: "）：",
            afterSecondUnderlineTitle2Normal: "，请填写定价 1。）：",
            //content1: "",
            content2: `（请根据午膳供应商在合约列明的定价，或因应其他午膳安排模式而知会家长的定价填写。）`,
            content2Normal: `（请根据午膳供应商在合约列明的定价，或因应其他午膳安排模式而知会家长的定价填写。）`,

            price1: "定价1（适用学生）",
            price2: "定价2（适用学生）",
            // price3: "定价3（适用于半日上课安排的餐盒）港币",
            HKD: "港币",
            title3: "(3) 预计为学生安排在校免费午膳的日数（<i>午膳日数可不等同于上学日数</i>）：",
            content3: "(i) {{startOfDaysLabel}}（{{endOfDaysLabel}}）：",
            day1: " 日",
            content4: "(ii) {{startOfSecDaysLabel}}{{endOfSecDaysLabel}}：",
            day2: " 日",
            dayMsg: "数字",
            tooltip1:
                "只适用于教育局宣布小学因疫情必须实行半天面授课堂的情况。",
            tooltip2: "参加学校请填妥甲部，不参加学校请填妥乙部。",
        },
        partB: {
            title: "本校不参加「计划」，原因如下",
            mainCause: "原因",
            errMsg: "原因",
        },
        certification: "负责教职员姓名",
        telNo: "学校电话号码",
        fax: "传真号码",
        date: "日期",
        deadline: "截止日期",
        circularNumber: "通函编号",
        supervisorName: "校监姓名",
        title: "校监称谓",
        supervisorNameCN: "校监姓名",
        titleCN: "校监称谓（中）",
        supervisorNameEN: "校监姓名",
        titleEN: "校监称谓（英）",
        schoolName: "学校名称",
        schoolCode: "学校编号",
        email: "学校电邮",

        versionOptions: {
            normal: "普通版",
            special: "疫情特别版",
        },
        titleCNOptions: [
            "先生",
            "女士",
            "小姐",
            "太太",
            "博士",
            "教授",
            "牧師",
            "神父",
            "修女",
            "法師",
            "修士",
        ],
        titleENOptions: [
            "Mr",
            "Ms",
            "Miss",
            "Mrs",
            "Dr",
            "Prof",
            "Rev",
            "Fr",
            "Sr",
            "Ven",
            "Br",
        ],
        supervisorNameErrorMsg: "校监姓名（中）跟校监姓名（英）必须是对应的",
    },
    params: {
        schoolYear: "2021/22",
        circularNumber: "64/2021",
        endOfDaysLabelSc: "官立小学則至2022年3月",
        endOfSecDaysLabelSc: "（官立小学由2022年4月）至7月",
        startOfDaysLabelSc: "2021年9月至12月",
        startOfSecDaysLabelSc: "2022年1月",
    },
    note: {
        note1: `就本学年的「在校免费午膳」申请，本校已知悉有关计划的安排，并会妥善知会家长相关详情。`,
    },
};
export default Form003SC;
